import React, { useState, useEffect, useRef } from 'react';

// --- Reusable Component for Scroll Animations ---
const AnimatedSection = ({ children, delay = 0 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target); // Trigger only once
        }
      });
    }, { threshold: 0.1 });

    const currentRef = domRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return (
    <div
      ref={domRef}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: `opacity 0.8s ease-out ${delay}s, transform 0.8s ease-out ${delay}s`,
      }}
    >
      {children}
    </div>
  );
};

export const About = () => (
    <div className="container" style={{padding: '60px 20px', overflow: 'hidden'}}>
        <AnimatedSection>
            <h1 style={{marginBottom: '20px'}}>About Cremlora LLC</h1>
            <p style={{lineHeight: '1.8', fontSize: '1.1rem', color: '#555'}}>
                Cremlora LLC is your trusted partner in automotive sales. We believe in transparency, quality, and efficiency. Our mission is to elevate your driving experience by providing certified, reliable vehicles protected by industry-leading warranties.
            </p>
        </AnimatedSection>
    </div>
);

export const Careers = () => (
    <div className="container" style={{padding: '60px 20px', overflow: 'hidden'}}>
        <AnimatedSection>
            <h1 style={{marginBottom: '20px'}}>Careers</h1>
            <p style={{fontSize: '1.1rem', color: '#555', marginBottom: '30px'}}>
                Join our growing team! We are currently looking for Sales Representatives and Mechanics.
            </p>
        </AnimatedSection>
        
        <AnimatedSection delay={0.2}>
            <button 
                className="btn btn-primary"
                style={{transition: 'transform 0.2s', cursor: 'pointer', padding: '12px 25px'}}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
                Apply Now
            </button>
        </AnimatedSection>
    </div>
);

export const Export = () => (
    <div className="container" style={{padding: '60px 20px', overflow: 'hidden'}}>
        <AnimatedSection>
            <h1 style={{marginBottom: '20px'}}>International Export</h1>
            <p style={{lineHeight: '1.8', fontSize: '1.1rem', color: '#555'}}>
                We specialize in exporting vehicles globally. Contact our Export Department for rates and shipping logistics.
            </p>
        </AnimatedSection>
    </div>
);